{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "CTA",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "heading"
  ],
  "properties": {
    "heading": {
      "title": "Heading",
      "type": "string",
      "maxLength": 200
    },
    "buttonLabel": {
      "title": "Button label",
      "type": "string",
      "maxLength": 60
    },
    "buttonHref": {
      "title": "Button link",
      "type": "string",
      "maxLength": 500,
      "pattern": "^(|page:[0-9a-fA-F-]{36}|/[^\\s]*|https?://[^\\s]+|mailto:[^\\s]+|tel:[+0-9 ]+|#[A-Za-z0-9_-]*)$",
      "x-ui": "link"
    }
  }
}
